import { FilterType, NodeFilterType } from '../types'
import { ReferenceNodeTypes } from 'shared/types/ingestion'
import { DuplicateStandardsCleanup } from './DuplicateStandardsCleanup'
import { AllSkillLeaves } from './AllSkillLeaves'
import { AllQuestions } from './AllQuestions'
import { AllNodes } from './AllNodes'
import { WeightedSkillsConvert } from './WeightedSkillsConvert'
import { DuplicatePointsCleanup } from './DuplicatePointsCleanup'

export enum PreDefinedFilterTypes {
  AllQuestions = 'All Questions',
  DuplicateSkills = 'Duplicate Skills',
  AllSkillLeaves = 'All Skill Leaves',
  AllNodes = 'All Nodes',
  WeightedSkillsList = 'Weighted Skills List',
  DuplicatePointsLeaves = 'Duplicate Points Leaves',
}

export const filterComponents = {
  [PreDefinedFilterTypes.DuplicateSkills]: DuplicateStandardsCleanup,
  [PreDefinedFilterTypes.AllSkillLeaves]: AllSkillLeaves,
  [PreDefinedFilterTypes.AllQuestions]: AllQuestions,
  [PreDefinedFilterTypes.AllNodes]: AllNodes,
  [PreDefinedFilterTypes.WeightedSkillsList]: WeightedSkillsConvert,
  [PreDefinedFilterTypes.DuplicatePointsLeaves]: DuplicatePointsCleanup,
}

export const emptyNodeFilter: NodeFilterType = {
  filterType: FilterType.node,
  typeSelections: {
    filterType: 'excluding',
    types: [...ReferenceNodeTypes],
  },
}
